export const showNewProductAction =state=>{
    return{
        type:"STATE_SHOW_PRODUCTS",
        payload:state,
    };
};

